import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=0b1dc0d4&scoped=true&"
import script from "./warehouse.vue?vue&type=script&lang=js&"
export * from "./warehouse.vue?vue&type=script&lang=js&"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=0b1dc0d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1dc0d4",
  null
  
)

export default component.exports